import { StarRemoveOutlineIcon } from './StarRemoveOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 40769B91-9676-413A-8D6D-9D21132637E2
 * name star-remove-outline
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-remove-outline.svg
 * tags
 * - Shape 
 */
export const FavoriteRemoveOutlineIcon = StarRemoveOutlineIcon;
export default FavoriteRemoveOutlineIcon